import { PayloadAction } from '@reduxjs/toolkit';
import { MembershipService, PrivateSpaceService } from './type';

const reducers = {
  getPrivateService(state, action: PayloadAction<PrivateSpaceService>) {
    state.privateSpace = action.payload;
    return state;
  },
  setMembershipService(state, action: PayloadAction<MembershipService>) {
    state.membershipService = action.payload;
    return state;
  },
};

export default reducers;
